// Utils
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import { get } from 'lodash';

export default function buildCityString(cityData) {
  const cityName = get(cityData, 'name');
  const stateName = get(cityData, 'state_abbr');
  return `${cityName}, ${stateName}`;
}
